// banking/src/pages/onboarding/corporate/utils/phoneCountryCodes.ts

export interface PhoneCountryCode {
  code: string;
  country: string;
  iso2: string;
}

export const PHONE_COUNTRY_CODES: PhoneCountryCode[] = [
  { code: '+93', country: 'Afghanistan', iso2: 'AF' },
  { code: '+355', country: 'Albania', iso2: 'AL' },
  { code: '+213', country: 'Algeria', iso2: 'DZ' },
  { code: '+1-684', country: 'American Samoa', iso2: 'AS' },
  { code: '+376', country: 'Andorra', iso2: 'AD' },
  { code: '+244', country: 'Angola', iso2: 'AO' },
  { code: '+1-264', country: 'Anguilla', iso2: 'AI' },
  { code: '+1-268', country: 'Antigua and Barbuda', iso2: 'AG' },
  { code: '+54', country: 'Argentina', iso2: 'AR' },
  { code: '+374', country: 'Armenia', iso2: 'AM' },
  { code: '+297', country: 'Aruba', iso2: 'AW' },
  { code: '+61', country: 'Australia', iso2: 'AU' },
  { code: '+43', country: 'Austria', iso2: 'AT' },
  { code: '+994', country: 'Azerbaijan', iso2: 'AZ' },
  { code: '+1-242', country: 'Bahamas', iso2: 'BS' },
  { code: '+973', country: 'Bahrain', iso2: 'BH' },
  { code: '+880', country: 'Bangladesh', iso2: 'BD' },
  { code: '+1-246', country: 'Barbados', iso2: 'BB' },
  { code: '+375', country: 'Belarus', iso2: 'BY' },
  { code: '+32', country: 'Belgium', iso2: 'BE' },
  { code: '+501', country: 'Belize', iso2: 'BZ' },
  { code: '+229', country: 'Benin', iso2: 'BJ' },
  { code: '+1-441', country: 'Bermuda', iso2: 'BM' },
  { code: '+975', country: 'Bhutan', iso2: 'BT' },
  { code: '+591', country: 'Bolivia', iso2: 'BO' },
  { code: '+387', country: 'Bosnia and Herzegovina', iso2: 'BA' },
  { code: '+267', country: 'Botswana', iso2: 'BW' },
  { code: '+55', country: 'Brazil', iso2: 'BR' },
  { code: '+246', country: 'British Indian Ocean Territory', iso2: 'IO' },
  { code: '+1-284', country: 'British Virgin Islands', iso2: 'VG' },
  { code: '+673', country: 'Brunei', iso2: 'BN' },
  { code: '+359', country: 'Bulgaria', iso2: 'BG' },
  { code: '+226', country: 'Burkina Faso', iso2: 'BF' },
  { code: '+257', country: 'Burundi', iso2: 'BI' },
  { code: '+855', country: 'Cambodia', iso2: 'KH' },
  { code: '+237', country: 'Cameroon', iso2: 'CM' },
  { code: '+1', country: 'Canada', iso2: 'CA' },
  { code: '+238', country: 'Cape Verde', iso2: 'CV' },
  { code: '+1-345', country: 'Cayman Islands', iso2: 'KY' },
  { code: '+236', country: 'Central African Republic', iso2: 'CF' },
  { code: '+235', country: 'Chad', iso2: 'TD' },
  { code: '+56', country: 'Chile', iso2: 'CL' },
  { code: '+86', country: 'China', iso2: 'CN' },
  { code: '+61', country: 'Christmas Island', iso2: 'CX' },
  { code: '+61', country: 'Cocos Islands', iso2: 'CC' },
  { code: '+57', country: 'Colombia', iso2: 'CO' },
  { code: '+269', country: 'Comoros', iso2: 'KM' },
  { code: '+682', country: 'Cook Islands', iso2: 'CK' },
  { code: '+506', country: 'Costa Rica', iso2: 'CR' },
  { code: '+385', country: 'Croatia', iso2: 'HR' },
  { code: '+53', country: 'Cuba', iso2: 'CU' },
  { code: '+599', country: 'Curacao', iso2: 'CW' },
  { code: '+357', country: 'Cyprus', iso2: 'CY' },
  { code: '+420', country: 'Czech Republic', iso2: 'CZ' },
  { code: '+243', country: 'Democratic Republic of the Congo', iso2: 'CD' },
  { code: '+45', country: 'Denmark', iso2: 'DK' },
  { code: '+253', country: 'Djibouti', iso2: 'DJ' },
  { code: '+1-767', country: 'Dominica', iso2: 'DM' },
  { code: '+1-809', country: 'Dominican Republic', iso2: 'DO' },
  { code: '+670', country: 'East Timor', iso2: 'TL' },
  { code: '+593', country: 'Ecuador', iso2: 'EC' },
  { code: '+20', country: 'Egypt', iso2: 'EG' },
  { code: '+503', country: 'El Salvador', iso2: 'SV' },
  { code: '+240', country: 'Equatorial Guinea', iso2: 'GQ' },
  { code: '+291', country: 'Eritrea', iso2: 'ER' },
  { code: '+372', country: 'Estonia', iso2: 'EE' },
  { code: '+251', country: 'Ethiopia', iso2: 'ET' },
  { code: '+500', country: 'Falkland Islands', iso2: 'FK' },
  { code: '+298', country: 'Faroe Islands', iso2: 'FO' },
  { code: '+679', country: 'Fiji', iso2: 'FJ' },
  { code: '+358', country: 'Finland', iso2: 'FI' },
  { code: '+33', country: 'France', iso2: 'FR' },
  { code: '+689', country: 'French Polynesia', iso2: 'PF' },
  { code: '+241', country: 'Gabon', iso2: 'GA' },
  { code: '+220', country: 'Gambia', iso2: 'GM' },
  { code: '+995', country: 'Georgia', iso2: 'GE' },
  { code: '+49', country: 'Germany', iso2: 'DE' },
  { code: '+233', country: 'Ghana', iso2: 'GH' },
  { code: '+350', country: 'Gibraltar', iso2: 'GI' },
  { code: '+30', country: 'Greece', iso2: 'GR' },
  { code: '+299', country: 'Greenland', iso2: 'GL' },
  { code: '+1-473', country: 'Grenada', iso2: 'GD' },
  { code: '+1-671', country: 'Guam', iso2: 'GU' },
  { code: '+502', country: 'Guatemala', iso2: 'GT' },
  { code: '+44-1481', country: 'Guernsey', iso2: 'GG' },
  { code: '+224', country: 'Guinea', iso2: 'GN' },
  { code: '+245', country: 'Guinea-Bissau', iso2: 'GW' },
  { code: '+592', country: 'Guyana', iso2: 'GY' },
  { code: '+509', country: 'Haiti', iso2: 'HT' },
  { code: '+504', country: 'Honduras', iso2: 'HN' },
  { code: '+852', country: 'Hong Kong', iso2: 'HK' },
  { code: '+36', country: 'Hungary', iso2: 'HU' },
  { code: '+354', country: 'Iceland', iso2: 'IS' },
  { code: '+91', country: 'India', iso2: 'IN' },
  { code: '+62', country: 'Indonesia', iso2: 'ID' },
  { code: '+98', country: 'Iran', iso2: 'IR' },
  { code: '+964', country: 'Iraq', iso2: 'IQ' },
  { code: '+353', country: 'Ireland', iso2: 'IE' },
  { code: '+44-1624', country: 'Isle of Man', iso2: 'IM' },
  { code: '+972', country: 'Israel', iso2: 'IL' },
  { code: '+39', country: 'Italy', iso2: 'IT' },
  { code: '+225', country: 'Ivory Coast', iso2: 'CI' },
  { code: '+1-876', country: 'Jamaica', iso2: 'JM' },
  { code: '+81', country: 'Japan', iso2: 'JP' },
  { code: '+44-1534', country: 'Jersey', iso2: 'JE' },
  { code: '+962', country: 'Jordan', iso2: 'JO' },
  { code: '+7', country: 'Kazakhstan', iso2: 'KZ' },
  { code: '+254', country: 'Kenya', iso2: 'KE' },
  { code: '+686', country: 'Kiribati', iso2: 'KI' },
  { code: '+383', country: 'Kosovo', iso2: 'XK' },
  { code: '+965', country: 'Kuwait', iso2: 'KW' },
  { code: '+996', country: 'Kyrgyzstan', iso2: 'KG' },
  { code: '+856', country: 'Laos', iso2: 'LA' },
  { code: '+371', country: 'Latvia', iso2: 'LV' },
  { code: '+961', country: 'Lebanon', iso2: 'LB' },
  { code: '+266', country: 'Lesotho', iso2: 'LS' },
  { code: '+231', country: 'Liberia', iso2: 'LR' },
  { code: '+218', country: 'Libya', iso2: 'LY' },
  { code: '+423', country: 'Liechtenstein', iso2: 'LI' },
  { code: '+370', country: 'Lithuania', iso2: 'LT' },
  { code: '+352', country: 'Luxembourg', iso2: 'LU' },
  { code: '+853', country: 'Macau', iso2: 'MO' },
  { code: '+389', country: 'Macedonia', iso2: 'MK' },
  { code: '+261', country: 'Madagascar', iso2: 'MG' },
  { code: '+265', country: 'Malawi', iso2: 'MW' },
  { code: '+60', country: 'Malaysia', iso2: 'MY' },
  { code: '+960', country: 'Maldives', iso2: 'MV' },
  { code: '+223', country: 'Mali', iso2: 'ML' },
  { code: '+356', country: 'Malta', iso2: 'MT' },
  { code: '+692', country: 'Marshall Islands', iso2: 'MH' },
  { code: '+222', country: 'Mauritania', iso2: 'MR' },
  { code: '+230', country: 'Mauritius', iso2: 'MU' },
  { code: '+262', country: 'Mayotte', iso2: 'YT' },
  { code: '+52', country: 'Mexico', iso2: 'MX' },
  { code: '+691', country: 'Micronesia', iso2: 'FM' },
  { code: '+373', country: 'Moldova', iso2: 'MD' },
  { code: '+377', country: 'Monaco', iso2: 'MC' },
  { code: '+976', country: 'Mongolia', iso2: 'MN' },
  { code: '+382', country: 'Montenegro', iso2: 'ME' },
  { code: '+1-664', country: 'Montserrat', iso2: 'MS' },
  { code: '+212', country: 'Morocco', iso2: 'MA' },
  { code: '+258', country: 'Mozambique', iso2: 'MZ' },
  { code: '+95', country: 'Myanmar', iso2: 'MM' },
  { code: '+264', country: 'Namibia', iso2: 'NA' },
  { code: '+674', country: 'Nauru', iso2: 'NR' },
  { code: '+977', country: 'Nepal', iso2: 'NP' },
  { code: '+31', country: 'Netherlands', iso2: 'NL' },
  { code: '+599', country: 'Netherlands Antilles', iso2: 'AN' },
  { code: '+687', country: 'New Caledonia', iso2: 'NC' },
  { code: '+64', country: 'New Zealand', iso2: 'NZ' },
  { code: '+505', country: 'Nicaragua', iso2: 'NI' },
  { code: '+227', country: 'Niger', iso2: 'NE' },
  { code: '+234', country: 'Nigeria', iso2: 'NG' },
  { code: '+683', country: 'Niue', iso2: 'NU' },
  { code: '+850', country: 'North Korea', iso2: 'KP' },
  { code: '+1-670', country: 'Northern Mariana Islands', iso2: 'MP' },
  { code: '+47', country: 'Norway', iso2: 'NO' },
  { code: '+968', country: 'Oman', iso2: 'OM' },
  { code: '+92', country: 'Pakistan', iso2: 'PK' },
  { code: '+680', country: 'Palau', iso2: 'PW' },
  { code: '+970', country: 'Palestine', iso2: 'PS' },
  { code: '+507', country: 'Panama', iso2: 'PA' },
  { code: '+675', country: 'Papua New Guinea', iso2: 'PG' },
  { code: '+595', country: 'Paraguay', iso2: 'PY' },
  { code: '+51', country: 'Peru', iso2: 'PE' },
  { code: '+63', country: 'Philippines', iso2: 'PH' },
  { code: '+64', country: 'Pitcairn', iso2: 'PN' },
  { code: '+48', country: 'Poland', iso2: 'PL' },
  { code: '+351', country: 'Portugal', iso2: 'PT' },
  { code: '+1-787', country: 'Puerto Rico', iso2: 'PR' },
  { code: '+974', country: 'Qatar', iso2: 'QA' },
  { code: '+242', country: 'Republic of the Congo', iso2: 'CG' },
  { code: '+262', country: 'Reunion', iso2: 'RE' },
  { code: '+40', country: 'Romania', iso2: 'RO' },
  { code: '+7', country: 'Russia', iso2: 'RU' },
  { code: '+250', country: 'Rwanda', iso2: 'RW' },
  { code: '+590', country: 'Saint Barthelemy', iso2: 'BL' },
  { code: '+290', country: 'Saint Helena', iso2: 'SH' },
  { code: '+1-869', country: 'Saint Kitts and Nevis', iso2: 'KN' },
  { code: '+1-758', country: 'Saint Lucia', iso2: 'LC' },
  { code: '+590', country: 'Saint Martin', iso2: 'MF' },
  { code: '+508', country: 'Saint Pierre and Miquelon', iso2: 'PM' },
  { code: '+1-784', country: 'Saint Vincent and the Grenadines', iso2: 'VC' },
  { code: '+685', country: 'Samoa', iso2: 'WS' },
  { code: '+378', country: 'San Marino', iso2: 'SM' },
  { code: '+239', country: 'Sao Tome and Principe', iso2: 'ST' },
  { code: '+966', country: 'Saudi Arabia', iso2: 'SA' },
  { code: '+221', country: 'Senegal', iso2: 'SN' },
  { code: '+381', country: 'Serbia', iso2: 'RS' },
  { code: '+248', country: 'Seychelles', iso2: 'SC' },
  { code: '+232', country: 'Sierra Leone', iso2: 'SL' },
  { code: '+65', country: 'Singapore', iso2: 'SG' },
  { code: '+1-721', country: 'Sint Maarten', iso2: 'SX' },
  { code: '+421', country: 'Slovakia', iso2: 'SK' },
  { code: '+386', country: 'Slovenia', iso2: 'SI' },
  { code: '+677', country: 'Solomon Islands', iso2: 'SB' },
  { code: '+252', country: 'Somalia', iso2: 'SO' },
  { code: '+27', country: 'South Africa', iso2: 'ZA' },
  { code: '+82', country: 'South Korea', iso2: 'KR' },
  { code: '+211', country: 'South Sudan', iso2: 'SS' },
  { code: '+34', country: 'Spain', iso2: 'ES' },
  { code: '+94', country: 'Sri Lanka', iso2: 'LK' },
  { code: '+249', country: 'Sudan', iso2: 'SD' },
  { code: '+597', country: 'Suriname', iso2: 'SR' },
  { code: '+47', country: 'Svalbard and Jan Mayen', iso2: 'SJ' },
  { code: '+268', country: 'Swaziland', iso2: 'SZ' },
  { code: '+46', country: 'Sweden', iso2: 'SE' },
  { code: '+41', country: 'Switzerland', iso2: 'CH' },
  { code: '+963', country: 'Syria', iso2: 'SY' },
  { code: '+886', country: 'Taiwan', iso2: 'TW' },
  { code: '+992', country: 'Tajikistan', iso2: 'TJ' },
  { code: '+255', country: 'Tanzania', iso2: 'TZ' },
  { code: '+66', country: 'Thailand', iso2: 'TH' },
  { code: '+228', country: 'Togo', iso2: 'TG' },
  { code: '+690', country: 'Tokelau', iso2: 'TK' },
  { code: '+676', country: 'Tonga', iso2: 'TO' },
  { code: '+1-868', country: 'Trinidad and Tobago', iso2: 'TT' },
  { code: '+216', country: 'Tunisia', iso2: 'TN' },
  { code: '+90', country: 'Turkey', iso2: 'TR' },
  { code: '+993', country: 'Turkmenistan', iso2: 'TM' },
  { code: '+1-649', country: 'Turks and Caicos Islands', iso2: 'TC' },
  { code: '+688', country: 'Tuvalu', iso2: 'TV' },
  { code: '+1-340', country: 'U.S. Virgin Islands', iso2: 'VI' },
  { code: '+256', country: 'Uganda', iso2: 'UG' },
  { code: '+380', country: 'Ukraine', iso2: 'UA' },
  { code: '+971', country: 'United Arab Emirates', iso2: 'AE' },
  { code: '+44', country: 'United Kingdom', iso2: 'GB' },
  { code: '+1', country: 'United States', iso2: 'US' },
  { code: '+598', country: 'Uruguay', iso2: 'UY' },
  { code: '+998', country: 'Uzbekistan', iso2: 'UZ' },
  { code: '+678', country: 'Vanuatu', iso2: 'VU' },
  { code: '+379', country: 'Vatican', iso2: 'VA' },
  { code: '+58', country: 'Venezuela', iso2: 'VE' },
  { code: '+84', country: 'Vietnam', iso2: 'VN' },
  { code: '+681', country: 'Wallis and Futuna', iso2: 'WF' },
  { code: '+212', country: 'Western Sahara', iso2: 'EH' },
  { code: '+967', country: 'Yemen', iso2: 'YE' },
  { code: '+260', country: 'Zambia', iso2: 'ZM' },
  { code: '+263', country: 'Zimbabwe', iso2: 'ZW' },
];
